import {
  MissionTrackingExceptionalBonusInput,
  MissionTrackingInput
} from '../../lib/types/models/mission-tracking/mission-tracking-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateMissionTracking({ id, ...rest }: UpdateInput<MissionTrackingInput>) {
  return restApiClient.url(constructApiUrl(API.missionTrackings.update.url, { id })).patch(rest)
}

export function updateMissionTrackingExceptionalBonus({
  id,
  ...rest
}: UpdateInput<MissionTrackingExceptionalBonusInput>) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.updateExceptionalBonus.url, { id }))
    .patch(rest)
}
